import { createContext, useState } from 'react';
import { LocalizedText } from '@mews/framework';
import { Button, IconButton, IconName, Position, Sidebar, Stack, StackItem } from '@optimus-web/core';
import MenuContainer, { MenuContainerProps } from './MenuContainer';

export interface MobileMenuProps extends MenuContainerProps {
    nameKey: Mews.TextKey;
}

interface SidebarContext {
    isSidebarOpened?: boolean;
    toggleSidebar?: () => void;
}

export const MobileMenuSidebarContext = createContext<SidebarContext>({});

const MobileMenu: React.FC<MobileMenuProps> = ({ nameKey, handleNavigation, ...other }) => {
    const [isSidebarOpened, setSidebarOpened] = useState(false);
    const handleToggleSidebar = () => setSidebarOpened(!isSidebarOpened);
    const handleMenuClick: MobileMenuProps['handleNavigation'] = (value) => {
        handleNavigation(value);
        handleToggleSidebar();
    };

    return (
        <>
            <Stack>
                <StackItem padding="200">
                    <Button size="medium" onClick={handleToggleSidebar} type="submit">
                        <LocalizedText textKey={nameKey} />
                    </Button>
                </StackItem>
            </Stack>
            <Sidebar
                modal={false}
                opened={isSidebarOpened}
                onClose={handleToggleSidebar}
                position={Position.Left}
                closeOnBackdropClick
                verticallyPadded
            >
                <Stack alignment="end">
                    <StackItem padding="100">
                        <IconButton
                            icon={IconName.CrossClose}
                            variant="ghost"
                            onClick={handleToggleSidebar}
                            type="submit"
                        />
                    </StackItem>
                </Stack>
                <MobileMenuSidebarContext.Provider value={{ isSidebarOpened, toggleSidebar: handleToggleSidebar }}>
                    <MenuContainer {...other} handleNavigation={handleMenuClick} />
                </MobileMenuSidebarContext.Provider>
            </Sidebar>
        </>
    );
};

export default MobileMenu;
